import { services } from '@qompium/pages-helper-tools';
import { Status } from '../helpers/product';
import { GeneralConfig, Subscription } from '../models';
import * as apiClient from './apiClient';

const configurationServiceUrl = services.configurations;

export async function getGeneralConfiguration(source = 'mobile') {
  const endpoint = 'general';

  const result = await apiClient.get<GeneralConfiguration>(configurationServiceUrl, endpoint);
  const period = result?.data.periods.find(
    element => element.tags.indexOf(source) >= 0 && (element.free || !element.price)
  );

  const configuration: GeneralConfig = {
    freeTrialHash: period?.hash,
    termsOfUseLink: result?.data.documents.terms_of_use.url,
    privacyPolicyLink: result?.data.documents.privacy_policy.url,
    currencies: result?.data.currencies,
  };

  return configuration;
}

export async function getUserConfiguration(userId: string) {
  const endpoint = `users/${userId}`;

  return await apiClient.get<UserConfiguration>(configurationServiceUrl, endpoint);
}

export async function updateRecurringSubscription(
  userId: string,
  plan: string,
  billingPeriod: string | undefined,
  status: Status,
  nextPaymentTimestamp?: number
) {
  const endpoint = `users/${userId}`;

  const response = await apiClient.put<AffectedRecords>(
    configurationServiceUrl,
    endpoint,
    { data: { subscription: { plan, billingPeriod, status, nextPaymentTimestamp } } }
  );
  return response?.affectedRecords === 1;
}

export async function updateBillingPeriod(userId: string, billingPeriod: string | undefined) {
  const endpoint = `users/${userId}`;

  const response = await apiClient.put<AffectedRecords>(configurationServiceUrl, endpoint, { data: { subscription: { billingPeriod } } });
  return response?.affectedRecords === 1;
}

export interface GeneralConfiguration {
  id: string;
  data: {
    periods: Period[];
    documents: {
      [key: string]: Document;
    };
    currencies: {
      default: string;
      countries: {
        [countryCode: string]: string;
      };
    };
  };
}

export interface Document {
  url: string;
  version: string;
}

interface Period {
  hash: string;
  tags: string[];
  free?: boolean;
  price?: number;
}

interface UserConfiguration {
  id: string;
  patientConfigurations: PatientConfiguration[];
  data: {
    subscription: Subscription;
  };
}

export interface PatientConfiguration {
  groupId: string;
  data: {
    groupType: string;
  };
}

interface AffectedRecords {
  affectedRecords: number;
}
